import React from 'react';
import { Button} from 'reactstrap';
import { DeleteBranch } from './DeleteBranch';
import { FormBranch } from './FormBranch';
import { Dialog } from 'primereact/dialog';

export const ModalBranch = (props) => {

    const {
        modal, closeDialog, modalTitle, method, loading,
        states, municipalities, commercialLines,
        handleInputChange, validaciones,
        id_commercial_line, name, code, number_phone, email, id_state, id_municipality,
        address, colony, cp, url, logo, name_responsible, certificate, image_firm, toma,
        imageLogo, imageFirm, imageBackground,
        saveCreate, saveDelete, saveUpdate,
        handleChangeState,
        previewLogo, previewFirm, previewBackground, imageHandler,roleUser_responsible
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end"}}>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
        </div>
    );

    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='large-dialog'
            footer={footer}>
          
            {
                method === "create"
                    ? <FormBranch
                        button="Guardar"
                        {...{loading, handleInputChange, validaciones, methodAction: saveCreate, states, municipalities, commercialLines, handleChangeState, previewLogo, previewFirm, previewBackground, imageHandler,roleUser_responsible }}
                    />
                    : (method === "update")

                        ?
                        <FormBranch
                            button="Actualizar"
                            {...{
                                loading, handleInputChange, validaciones, methodAction: saveUpdate, states, municipalities, commercialLines, handleChangeState, previewLogo, previewFirm, previewBackground, imageHandler, id_commercial_line, name, code,
                                number_phone, email, id_state, id_municipality,
                                address, colony, cp, url, logo, name_responsible, certificate, image_firm, toma, imageLogo, imageFirm, imageBackground,roleUser_responsible
                            }}
                        />
                        :
                        <DeleteBranch
                            {...{loading, saveDelete, name, code }}
                        />
            }
        </Dialog>
    )
}
